/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
//import _ from 'lodash';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { FETCH_HEXON, FETCH_HEXON_CONTROL_PANEL_URL } from './constants';

export const initialState = {
  ads: {},
  controlPanelUrl : null
};

export const HexonReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case FETCH_HEXON:
            draft.ads = action.result.results;
            break;
        case FETCH_HEXON_CONTROL_PANEL_URL:
            draft.controlPanelUrl = action.result.url;
            debugger
        break;
        }
    }
  });
};
